import toast from 'utils/toast'
import institutionAPI from 'services/institutionAPI'

type Params = {
  fileId?: string
  fileSlug?: string
  archiveId?: string
}

export default async function getFileFromArchive({ archiveId, fileId, fileSlug }: Params) {
  const response = await institutionAPI({
    method: 'GET',
    url: `/archive/file/archive/${archiveId}/file/${fileId}/${fileSlug}`,
  })

  if (!response?.header?.success) {
    toast.error(response?.header?.message)
  }

  return response
}
